<script setup>
import { computed } from 'vue';
import { formatNumber } from './metricsHelpers';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: Number, default: null },
  delta: { type: Number, default: null },
  deltaLabel: { type: String, default: '' },
  format: { type: Function, default: formatNumber },
});

const trend = computed(() => {
  if (props.delta == null) return null;
  const rounded = Math.round(props.delta);
  return {
    text: `${rounded > 0 ? '+' : ''}${rounded}%`,
    icon: rounded >= 0 ? 'i-lucide-trending-up' : 'i-lucide-trending-down',
    tone: rounded >= 0 ? 'text-n-teal-11' : 'text-n-ruby-11',
  };
});
</script>

<template>
  <div
    class="flex flex-col gap-1 rounded-xl border border-n-weak bg-n-solid-1 p-4"
  >
    <span class="text-xs font-medium uppercase tracking-wide text-n-slate-11">{{
      label
    }}</span>
    <span class="text-2xl font-semibold tabular-nums text-n-slate-12">{{
      format(value)
    }}</span>
    <span
      v-if="trend"
      data-test="delta"
      class="flex items-center gap-1 text-xs"
      :class="trend.tone"
    >
      <span :class="trend.icon" class="size-3.5" aria-hidden="true" />
      <span class="font-medium tabular-nums">{{ trend.text }}</span>
      <span class="text-n-slate-10">{{ deltaLabel }}</span>
    </span>
  </div>
</template>
